module.exports = __webpack_public_path__ + "img/alianzas-estrategicas.e381683d.jpg";